import firebase from 'firebase/app'
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage"

var firebaseConfig = {
  apiKey: "AIzaSyCGM7e14EFQVllEf3zCY-kJoM0Os2moDak",
  authDomain: "talentino-3c817.firebaseapp.com",
  databaseURL: "https://talentino-3c817.firebaseio.com",
  projectId: "talentino-3c817",
  storageBucket: "talentino-3c817.appspot.com",
  messagingSenderId: "368409000045",
  appId: "1:368409000045:web:f2b978de5980c6b3156764",
  measurementId: "G-ST40NTL97N",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export const firestore = firebase.firestore();
export const auth = firebase.firestore();
export const storage = firebase.storage();

export default firebase